import _ from 'lodash';
import qs from 'qs'

export default function incentivesReducer(state = {
    incentives: [],
    incentive: [],
    paging: {
      number: 1,
      size: 10
    },
    meta:[],
    fetching: false,
    fetched: false,
    errors: {}
  }, action) {
    switch (action.type) {
      case 'GET_INCENTIVE_PENDING':
      case 'ADD_INCENTIVES_PENDING':
      case 'GET_INCENTIVES_PENDING': {
        return {
          ...state,
          fetching: true,
          fetched: false
        }
      }
      case 'GET_INCENTIVE_FULFILLED': {
        const data = action.payLoad.data;
        const meta = action.payLoad.meta;
        let newMeta = meta;

        let incentiveTypes = {};

        // TODO remove
        _.each(meta["incentive-types"], function (value, key) {
          key = key.replace(/-/g, '_');
          incentiveTypes[key] = value;
        });

        let incentiveRewardTypes = {};

        // TODO remove
        _.each(meta["reward-types"], function (value, key) {
          key = key.replace(/-/g, '_');
          incentiveRewardTypes[key] = value;
        });
        newMeta["incentive-types"] = incentiveTypes;
        newMeta["incentive-reward-types"] = incentiveRewardTypes;
        return {
          ...state,
          fetching: false,
          fetched: true,
          incentive: data,
          meta: newMeta
        }
      }
      case 'ADD_INCENTIVE_FULFILLED': {
        return {
          ...state
        }
      }
      case 'GET_INCENTIVES_FULFILLED': {
        const lastPage = action.payLoad.links.last;
        let page = state.paging;
        if (lastPage) {
          page = qs.parse(lastPage.split('?')[1]).page;
        }

        return {
          ...state,
          fetching: false,
          fetched: true,
          incentives: action.payLoad.data,
          paging: page
        }
      }
      case 'GET_INCENTIVE_REJECTED':
      case 'ADD_INCENTIVES_REJECTED': {
        return {
          ...state,
          fetching: false,
          errors: action.payload.errors,
        };
      }
      case 'GET_INCENTIVES_REJECTED': {
        // return {...state, errors: action.payLoad.errors}
      }
      default: {
        return {...state};
      }
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/incentivesReducer.js